export default __webpack_public_path__ + "images/9588aa6c07b99f45c569e40b9edd94ad.svg";